module.exports = __webpack_public_path__ + "media/images/newsletters__icon__selected-3ba64ea7510decfd20b22eb8a963a7f8.svg";